module.exports = __webpack_public_path__ + "static/media/tvl-bg.4ca5bfe7.svg";